import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Row, Col, Input, InputNumber, Button, DatePicker } from 'antd';
import moment from 'moment';

import './NewMaintenanceModal.css';
import { api } from '../../../services';

@inject('translationsStore', 'commonStore')
@observer
export default class NewMaintenanceModal extends Component {
  constructor(props) {
    super(props);
    this.defaultAddValues = {
      description: '',
      km: '',
      moment: null,
      date: ''
    };
    this.state = {
      modalAddLoading: false,
      modalCanAdd: false,
      modalAddDescription: this.defaultAddValues.description,
      modalAddKm: this.defaultAddValues.km,
      modalAddMoment: this.defaultAddValues.moment,
      modalAddDate: this.defaultAddValues.date
    };
  }

  onAddDescriptionChange = e => {
    this.setState({ modalAddDescription: e.target.value }, () => {
      this.checkProcessing();
    });
  };

  onAddKmChange = e => {
    const { modalAddKm: prevValue } = this.state;
    let value = e.target.value.trim() === '' ? '' : isNaN(e.target.value) ? prevValue : parseInt(e.target.value, 10);
    this.setState({ modalAddKm: value }, () => {
      this.checkProcessing();
    });
  };

  onAddDateChange = (date, dateString) => {
    const newDate = date !== null ? date.format('YYYY-MM-DD') : '';
    this.setState({ modalAddMoment: date, modalAddDate: newDate }, () => {
      this.checkProcessing();
    });
  };

  checkProcessing = () => {
    const { modalAddDescription, modalAddKm, modalAddDate } = this.state;
    const modalCanAdd = modalAddDescription !== '' && (modalAddDate !== '' || modalAddKm !== '');
    this.setState({ modalCanAdd });
  };

  addMaintenance = () => {
    this.setState({ modalCanAdd: false, modalAddLoading: true });
    const { carId, onOk, onError, onCancel } = this.props;
    let { modalAddDescription: description, modalAddKm: km, modalAddDate: date } = this.state;
    km = km !== '' ? km : undefined;
    date = date !== '' ? date : undefined;
    api('addMaintenance', { carId, description, km, date })
      .then(response => {
        this.setState(
          {
            modalAddLoading: false,
            modalCanAdd: false,
            modalAddDescription: this.defaultAddValues.description,
            modalAddKm: this.defaultAddValues.km,
            modalAddMoment: this.defaultAddValues.moment,
            modalAddDate: this.defaultAddValues.date
          },
          () => {
            onOk instanceof Function && onOk(response);
          }
        );
      })
      .catch(error => {
        this.setState(
          {
            modalAddLoading: false,
            modalCanAdd: true
          },
          () => {
            onError instanceof Function && onError(error);
          }
        );
      });
  };

  cancel = () => {
    const { onCancel } = this.props;
    onCancel instanceof Function && onCancel();
  };

  render() {
    const { translationsStore, commonStore } = this.props;
    return this.props.carId ? (
      <Modal
        {...this.props}
        className={`NewMaintenanceModal ${this.props.className}`}
        visible={this.props.visible}
        onCancel={this.cancel}
        onOk={this.addMaintenance}
        title={translationsStore.translate('newMaintenances.modal.title')}
        width="calc(var(--tablet-width) / var(--modal-width-ratio))"
        getContainer={() => document.getElementById('MaintenanceCard')}
        centered={true}
        footer={[
          <Button key="cancel" onClick={this.cancel}>
            {translationsStore.translate('newMaintenances.modal.cancel')}
          </Button>,
          <Button key="ok" type="primary" loading={this.state.modalAddLoading} onClick={this.addMaintenance} disabled={!this.state.modalCanAdd}>
            OK
          </Button>
        ]}
      >
        <Fragment>
          <Row style={{ marginBottom: 20 }}>
            <Col span={12}>{translationsStore.translate('newMaintenances.modal.labelDescription')}</Col>
            <Col span={12}>
              <Input
                value={this.state.modalAddDescription}
                onChange={this.onAddDescriptionChange}
                placeholder={translationsStore.translate('newMaintenances.modal.labelDescription')}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col span={12}>{translationsStore.translate('newMaintenances.modal.labelKm')}</Col>
            <Col span={12}>
              <InputNumber
                value={this.state.modalAddKm}
                onKeyUp={this.onAddKmChange}
                placeholder={translationsStore.translate('newMaintenances.modal.labelKm')}
                style={{ width: 171 }}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col span={12}>{translationsStore.translate('newMaintenances.modal.labelDate')}</Col>
            <Col span={12}>
              <DatePicker
                showToday={true}
                format={commonStore.longDateFormat.L}
                value={this.state.modalAddMoment}
                onChange={this.onAddDateChange}
                disabledDate={currentDate => moment(currentDate).isBefore(moment(new Date()).subtract(1, 'day'))}
              />
            </Col>
          </Row>
        </Fragment>
      </Modal>
    ) : (
      <Fragment />
    );
  }
}
